import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { useState } from "preact/hooks";

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
            aria-label={`Remove filter ${filter.name} ${filter.value}`}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters();
    const [filteredByString, setFilteredByString] = useState('');
    const collectionHeading = document.querySelector('.collection-header__heading').textContent;

    let filtersByGroups = {};
    
    if (filters.length > 0) {
        filters.forEach(filter => {
            const { name, value } = filter;
            if (!filtersByGroups[name]) {
                filtersByGroups[name] = [];
            }
            filtersByGroups[name].push(value);
        });

        let filteredByStr = 'Filtered by: ';

        const filterStrings = Object.keys(filtersByGroups).map(name => {
            return `${filtersByGroups[name].join(' and ')} ${name}`;
        });
        filteredByStr += filterStrings.join(' and ');

        setFilteredByString(filteredByStr);
    } else {
        setFilteredByString(`Results for ${collectionHeading ?? ''}`);
    }

    return (
        <>
            <div role="status" aria-live="polite" class="sr-only">{filteredByString}</div> 
            {
                filters.length > 0 && (
                    <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2">
                        <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                            {filters.map(filter => (
                                <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-px-1 ns-mr-1 ns-mb-1 ns-font-4">
                                    <span class="ns-color-black">
                                        {filter.name}: {filter.value}
                                    </span>
                                    <FilterRemoveButton filter={filter} />
                                </div>
                            ))}
                        </div>
                        <a
                            href="javascript:void(0)"
                            class="ns-col-2 ns-text-undecorated ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto "
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear Filters
                        </a>
                    </div>
                )      
            }
        </>
      
    )
}
